<template>
  <div class="py-10">
    <div class="flex justify-center text-center flex-col gap-2 py-5">
      <JadeText
        color="medium"
        variant="heading-xsmall"
      >
        {{ $t('title') }}
      </JadeText>
      <JadeText
        color="medium"
        variant="medium"
      >
        {{ $t('description') }}
      </JadeText>
    </div>
  </div>
</template>
<script>
import { JadeText } from '@jade'
export default {
  name: 'EmptyState',
  components: {
    JadeText
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Nenhuma contestação encontrada",
      "description": "Escolha outros filtros disponíveis e tente de novo."
    },
    "en-US": {
      "title": "No disputes found",
      "description": "Choose another filter method and try again."
    }
  }
</i18n>
